// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Face_style_b-icon-warning__Qjq0o","wrapper":"Face_style_wrapper__10ysw","content":"Face_style_content__d4-xr","rotate":"Face_style_rotate__7cTcv"};